import { Injectable } from '@angular/core';
import Clarity from '@microsoft/clarity';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ClarityService {

    loginEventName = 'clarity-login-event';
    private readonly events = {
        [this.loginEventName]: 'clarity_on_login'
    };

    loadUserClarity(dataInfo: any, numberOfTries = 0): void {

        Clarity.init(environment.clarityId);

        Clarity.identify(dataInfo.tokenStaff, undefined, undefined, dataInfo.email);

        Clarity.setTag('name', dataInfo.firstName);
        Clarity.setTag('lastname', dataInfo.lastname);
        Clarity.setTag('email', dataInfo.email);
        Clarity.setTag('city', dataInfo.city);
        Clarity.setTag('country', dataInfo.country);
        Clarity.setTag('role', dataInfo.role);
        Clarity.setTag('permission', dataInfo.permission);
        Clarity.setTag('business_model', dataInfo.business_model);
        Clarity.setTag('studio_model', dataInfo.studio_model);
        Clarity.setTag('centerSubcriptionType', dataInfo.centerSubcriptionType);
        Clarity.setTag('idCenter', dataInfo.idCenter);
        Clarity.setTag('centerName', dataInfo.centerName);

        this.sendEvent(this.loginEventName);
    }

    sendEvent(eventName: string): void {

        if (this.isEventSent(eventName)) {
            return;
        }

        Clarity.event(this.events[eventName]);
        this.setEventAsSent(eventName);
    }

    isEventSent(eventName: string): boolean {
        const eventNameObject = sessionStorage.getItem(eventName);
        if (eventNameObject) {
            return JSON.parse(eventNameObject);
        } else {
            return false;
        }
    }

    private setEventAsSent(eventName: string): void {
        sessionStorage.setItem(eventName, 'true');
    }
}
